module.exports = __webpack_public_path__ + "static/check-one-banner-photo-72ea7b3e183de67ff6a89835be2599c6.jpg";